// @ts-nocheck
import { useSelector } from 'react-redux';
import { PERMISSION_TYPES } from '../constants';

const useAdmin = () => {
    const permissions = useSelector(state => state.auth.user.roleNames || {});
    return menuId => permissions[menuId]?.length === Object.keys(PERMISSION_TYPES).length;
};

export default useAdmin;
